import { FileContentGUID, type VirtualFile } from "@pdfking/pdfengine"
import { CacheFunction } from "@pdfking/storage"

import { RequestContent } from "./Functions"

export const BlobUrl = CacheFunction(
  (file: VirtualFile): Promise<string> =>
    RequestContent(file)
      .then(r => r.blob())
      .then(URL.createObjectURL),
  FileContentGUID
)
